import React, { useContext, useState } from 'react'

import { useMutation } from '@apollo/client'

import notify, { readableError } from 'tools/Notify'
import { MaxViewPage } from 'tools/Uniform'
import { isEmail } from 'utils/string'

import GlobalContext from 'reducer/global'

import { LOAD_ORG, ORG_INVITE } from '../graphql'
import OrgContext from '../reducer'
import ShowInvites from './Invites'
import ShowMembers from './Show'

function Members() {
  const [{ user }] = useContext(GlobalContext)
  const [org] = useContext(OrgContext)
  const [add, setAdd] = useState(false)
  const canChange = user.can('org_manage_members')

  const numInvites = org.pendingInvites.length

  return (
    <MaxViewPage>
      <h1 className="mb3">Members</h1>
      <ShowMembers canChange={canChange} />
      {canChange && (
        <>
          <div>
            {add ? (
              <Invite close={() => setAdd(false)} />
            ) : (
              <button className="neutral medium mt3" onClick={() => setAdd(true)}>
                <i className="fas fa-plus mr2" />
                Invite Member
              </button>
            )}
          </div>
        </>
      )}
      {numInvites > 0 && (
        <>
          <h2 className="mt5 mb3">Pending Invites</h2>
          <ShowInvites canChange={canChange} />
        </>
      )}
    </MaxViewPage>
  )
}

function Invite({ close }) {
  const [email, setEmail] = useState('')
  const [org] = useContext(OrgContext)
  const [, notifyD] = useContext(notify.Context)
  const orgId = org.id
  const [role, setRole] = useState('member')

  const [_makeInvite] = useMutation(ORG_INVITE, {
    variables: {
      action: 'REQUEST',
      role,
      orgId,
      email
    },
    refetchQueries: [{ query: LOAD_ORG, variables: { id: orgId } }],
    onCompleted({ orgChange: data }) {
      if (data?.success === true) {
        notify.info(notifyD, `${email} invited with role ${role}`)
        close()
      } else {
        notify.error(notifyD, readableError(data?.reason))
      }
    }
  })

  const makeInvite = () => {
    if (isEmail(email)) {
      _makeInvite()
    } else {
      notify.error(notifyD, 'Invalid email')
    }
  }

  return (
    <div className="mt3 flex gh2">
      <input
        className="w-100 font-mono"
        value={email}
        onChange={(v) => setEmail(v.target.value)}
        placeholder="Invite email"
      />
      <SelectRole role={role} onChange={setRole} />
      <button className="neutral" onClick={close}>
        Cancel
      </button>
      <button className="nowrap" onClick={makeInvite}>
        Send Invite
      </button>
    </div>
  )
}

export function SelectRole({ role, onChange }) {
  return (
    <select defaultValue={role} onChange={(e) => onChange(e.target.value)}>
      <option value="member">Member</option>
      <option value="admin">Admin — Can also manage members and billing</option>
      <option value="owner">
        Owner — Can also change owners and close account
      </option>
    </select>
  )
}

export default Members
